import { Link } from "react-router-dom";
import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

import Erbilimg from "./erbil.jpg";
import mosulimg from "./mosul.jpg";
import Dohukimg from "./dohuk.jpg";
import Baghdadimg from "./baghdad.jpg";
import Koyaimg from "./koya.jpeg";
import Hamdanyah from "./Hamdanya.PNG";
const locations = [
  { name: "Point A", latitude: 51.505, longitude: -0.09 },
  { name: "Point B", latitude: 51.515, longitude: -0.1 },
];

const Proviences = () => {
  return (
    <>
      <section id="map" className="  myMap map features ">
        <h2 className="features-heading" style={{ textAlign: "right" }}>
          {" "}
          العراق :{" "}
        </h2>
        <div className="feature-cards">
          {[
            {
              title: " أربيل ",
              desc: "اضغط لعرض المتاجر في اربيل ",
              img: Erbilimg,
              routComp: "erbil",
            },
            {
              title: " كويسنجق ",
              desc: "اضغط لعرض المتاجر في كويسنجق ",
              img: Koyaimg,
              routComp: "koya",
            },
            {
              title: "  دهوك",
              desc: "اضغط لعرض المتاجر في دهوك",
              img: Dohukimg,
              routComp: "dohuk",
            },

            {
              title: "  الموصل ",
              desc: "اضغط لعرض المتاجر في الموصل",
              img: mosulimg,
              routComp: "mosul",
            },

            {
              title: "  بغداد",
              desc: "اضغط لعرض المتاجر في بغداد",
              img: Baghdadimg,
              routComp: "baghdad",
            },
            {
              title: "  الحمدانية",
              desc: "اضغط لعرض المتاجر في الحمدانية",
              img: Hamdanyah,
              routComp: "hamdanyah",
            },
          ].map((feature, index) => (
            <Link to={`/${feature.routComp}`}>
              <div
                key={index}
                className={`dark-locations  dark-cards feature-card provience`}
                style={{
                  background: `url(${feature.img}) `,
                  backgroundSize: "cover",
                  color: "white",
                  backgroundPosition: "center",
                }}
              >
                <h4
                  style={{
                    width: "fit-content",
                    background: "rgb(0,0,0,0.5)",
                    placeSelf: "end",
                    borderRadius: "5px",
                  }}
                >
                  <FaMapMarkerAlt className="check-icon" size={20} />
                  {feature.title}
                </h4>
                <p
                  style={{
                    width: "fit-content",
                    background: "rgb(0,0,0,0.5)",
                    placeSelf: "end",
                    borderRadius: "5px",
                    fontSize: "12px",
                  }}
                >
                  {feature.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};

export default Proviences;
